<template>
	<div class="Jump">
	  <p class="email">
			我们向你的邮箱 {{' " '+UrlParams.mail+' " ' }} 发出了一封确认信，你需要点击邮箱中的确认链接来完成注册
	  </p>
		<input type="button" value="打开邮箱查收" class="open" @click="JumpMail">
		<p class="Customer"> 如有疑问，请联系客服：010-84770602 </p>
	</div>
</template>
<style>
	.Jump{
		width:600px;
		position: absolute;
		left:50%;
		margin-left:-300px;
		margin-top:30px;
		box-shadow: 2px 2px 2px #ccc;
		border:solid 1px #ccc;
	}
	.Customer{
		margin: 50px auto;
	}
	.Jump > p{
		font-size:14px;
	}
	.open{
		background-color: #b71d2a;
		border:none;
		color:#fff;
		width:400px;
		height:35px;
		border-radius: 15px;
		margin-top:80px;
		cursor: pointer;
	}
	.email{
		width:400px;
		text-align: left;
		margin:40px auto;
	}
</style>
<script>
	export default {
		data () {
			return {
				UrlParams: {}
			}
		},
		mounted () {
			this.UrlParams = this.$queryUrlParams();
		},
		methods: {
			JumpMail () {
				var Email = this.UrlParams.mail.split("@")[1];
				if(Email == 'gmail.com'){
					window.location.href = 'https://mail.gmail.com/';
				}else if(Email == '163.com'){
					window.location.href = 'http://mail.163.com/';
				}else if(Email == '126.com'){
					window.location.href = 'http://mail.126.com/';
				}else if(Email == 'truthso.com'){
					window.location.href = 'http://mail.truthso.com/';
				}else if(Email == 'qq.com'){
					window.location.href = 'https://mail.qq.com/';
				}else{
					window.location.href = 'https://www.baidu.com/s?wd='+Email;
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// JumpMail.vue?5b7be3c4